export default __webpack_public_path__ + "static/media/twitter.a9d636c9.svg";